// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"a6661234","45":"87895131","164":"dd1d5e60","304":"3454a0be","646":"3992a1c8","787":"b2c3f5bb"}[chunkId] + ".chunk.js";
};